<div class="container-fluid">
  <form [formGroup]="insuranceClaimForm"
        (ngSubmit)="onSubmit()"
        [hasUnsavedData]="insuranceClaimForm">
    <button type="submit" hidden="hidden"></button>

    <!-- The contract is always derived from the context (a claim is created from a contract),
         so contractId is a hidden control, never entered manually. -->
    @if (this.contractIdFromContext() > 0) {
      <div class="row">
        <div class="col-6 col-lg-6">
          <div class="form-group">
            <label class="form-title-label" for="name" translate
            >INSURANCE_CLAIM_LBL_NAME</label
            >
            <input
              id="name"
              class="form-control form-title"
              type="text"
              formControlName="name"
              checkFormFieldValidity
              [maxLength]="100"
            />
          </div>
        </div>
        <div class="col"></div>
      </div>
      <div class="row">
        <div class="col-6 col-lg-6">
          <div class="form-group row">
            <label class="col-4 col-form-label-sm" translate>
              INSURANCE_CLAIM_LBL_TYPE
            </label>
            <div class="col">
              <app-typeahead
                [routeEndpoint]="'ClaimTypes'"
                [entity]="Entity.ClaimType"
                [controlForm]="this.insuranceClaimForm.controls['claimTypeId']"
                [orderBy]="'sequence asc, name asc'"
                [limitToList]="true"
                [domain]="claimTypeDomain()"
                [pageSize]="200"
              ></app-typeahead>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-4 col-form-label-sm" translate>
              INSURANCE_CLAIM_LBL_OCCURRENCE_DATE
            </label>
            <div class="col">
              <input
                type="date"
                class="form-control form-control-sm"
                formControlName="occurrenceDate"
                [max]="this.maxDateMaskSafeGuard"
                checkFormFieldValidity
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-4 col-form-label-sm" translate>
              INSURANCE_CLAIM_LBL_LIABILITY_RATE
            </label>
            <div class="col">
              <input
                class="form-control form-control-sm"
                type="text"
                [placeholder]="'%'"
                formControlName="liabilityRate"
                checkFormFieldValidity
                mask="percent"
                [suffix]="'PAYMENT_PLACEHOLDER_PERCENTAGE' | translate"
                [showMaskTyped]="false"
                [decimalMarker]="'.'"
                [allowNegativeNumbers]="false"
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-4 col-form-label-sm" translate>
              INSURANCE_CLAIM_LBL_ESTIMATED_AMOUNT
            </label>
            <div class="col">
              <input
                class="form-control form-control-sm"
                type="text"
                [placeholder]="'€'"
                formControlName="estimatedAmount"
                checkFormFieldValidity
                mask="separator.2"
                [suffix]="'PAYMENT_PLACEHOLDER_MONETARY' | translate"
                [showMaskTyped]="false"
                [decimalMarker]="'.'"
                [allowNegativeNumbers]="false"
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-4 col-form-label-sm" translate>
              INSURANCE_CLAIM_LBL_SALESPERSON
            </label>
            <div class="col">
              <app-typeahead
                [entity]="Entity.SalesTeam"
                [routeEndpoint]="'SalesTeams/SalesTeamMembers'"
                [controlForm]="insuranceClaimForm.get('salesPersonId')"
                [limitToList]="true"
                [dbNameOfName]="'UserContactName'"
                [dbNameOfId]="'UserId'"
                [domain]="this.salesPersonDomain"
                [pageSize]="100"
              ></app-typeahead>
            </div>
          </div>

        </div>
        <div class="col">
          <div class="form-group row invisible">
            <label class="col-4 col-form-label-sm" translate
            ></label
            >
            <div class="col">
              <input
                class="form-control form-control-sm"
                type="text"
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-4 col-form-label-sm" translate>
              INSURANCE_CLAIM_LBL_DECLARATION_DATE
            </label>
            <div class="col">
              <input
                type="date"
                class="form-control form-control-sm"
                [max]="this.maxDateMaskSafeGuard"
                formControlName="declarationDate"
                checkFormFieldValidity
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-4 col-form-label-sm" translate>
              INSURANCE_CLAIM_LBL_DEDUCTIBLE_AMOUNT
            </label>
            <div class="col">
              <input
                class="form-control form-control-sm"
                type="text"
                [placeholder]="'€'"
                formControlName="deductibleAmount"
                checkFormFieldValidity
                mask="separator.2"
                [suffix]="'PAYMENT_PLACEHOLDER_MONETARY' | translate"
                [showMaskTyped]="false"
                [decimalMarker]="'.'"
                [allowNegativeNumbers]="false"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-12 col-lg-12">
          <div class="form-group row">
            <label class="col-2 col-form-label-sm" translate>
              INSURANCE_CLAIM_LBL_DESCRIPTION
            </label>
            <div class="col">
            <textarea
              formControlName="description"
              class="form-control form-control-sm height-size"
              checkFormFieldValidity
            ></textarea>
            </div>
          </div>
        </div>
      </div>
    } @else {
      <span class="text-muted" translate>
      INSURANCE_CLAIM_LBL_NO_CONTRACT_SELECTED
    </span>
    }
  </form>
</div>
